import React, { useState, useEffect } from "react";
import { 
  Box, 
  useMediaQuery, 
  Typography, 
  Container,
  useTheme,
  alpha
} from "@mui/material";
import logo from "../assets/sb-logo.webp";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const isTablet = useMediaQuery(theme.breakpoints.up('sm'));
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 20;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        background: scrolled 
          ? '#ffb18a' // Warm peach background when scrolled
          : 'transparent',
        backdropFilter: scrolled ? 'blur(10px)' : 'none',
        borderBottom: scrolled 
          ? `1px solid ${alpha(theme.palette.divider, 0.1)}`
          : 'none',
        transition: 'all 0.3s ease-in-out',
        py: scrolled ? 1 : 2,
      }}
    >
        <Container maxWidth="xl">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 2,
            }}
          >
            {/* Logo Section */}
            <Box
              component="a"
              href="https://createshaadibiodata.com"
              rel="noopener noreferrer"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                textDecoration: 'none',
              }}
            >
              <Box
                component="img"
                src={logo}
                alt="Shaadi Biodata Logo"
                sx={{
                  width: { xs: 50, sm: 60, md: 70 },
                  height: { xs: 50, sm: 60, md: 70 },
                  objectFit: 'contain',
                  display: 'block',
                  border: 'none',
                  outline: 'none',
                  boxShadow: 'none',
                  bgcolor: 'transparent',
                }}
              />

            </Box>

            {/* Center Title - Desktop Only */}
            {isDesktop && (
              <Box
                sx={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center',
                  pointerEvents: 'none',
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    color: '#111', // Black title
                    textShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  }}
                >
                  {t("pageTitle")}
                </Typography>
              </Box>
            )}

            {/* Mobile Title */}
            {!isDesktop && (
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                  textAlign: 'center',
                  flex: 1,
                  fontSize: '1rem',
                }}
              >
                {t("pageTitleMobile")}
              </Typography>
            )}

            {/* Right Side - Future use for notifications, user menu, etc. */}
            <Box sx={{ width: { xs: 50, sm: 60, md: 70 } }} />
          </Box>
        </Container>
      </Box>
  );
};

export default Navbar;